<script setup>
import UserWrapper from '@/components/VisionAi/UserWrapper.vue';

const props = defineProps({
  text: {
    type: String,
    default: '',
  },
});
</script>

<template>
  <UserWrapper is-text-only-button class="!w-fit" data-test="user-message">
    <span>{{ props.text }}</span>
  </UserWrapper>
</template>
